import { withStyles } from '@material-ui/core'
import Button from '@material-ui/core/Button'

export const PrimaryBtn = withStyles(() => {
	return {
		root: {
			color: '#fff',
			fontSize: 13,
			lineHeight: '16px',
			fontWeight: 'normal',
			fontStyle: 'normal',
			textTransform: 'inherit',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-start',
			borderRadius: 4,
			border: '1px solid #3F4F5E',
			padding: '0 8px',
			height: '32px',
			minWidth: '100px',
			backgroundColor: '#3f4f5e',
			cursor: 'pointer',
			'&:hover': {
				backgroundColor: '#f7f7f7',
				color: 'rgba(0, 0, 0, 0.87)',
			},
			'&:active': {
				backgroundColor: '#e9f7fe',
				border: '1px solid #1baaf0',
				color: '#1baaf0',
			},
			'&:disabled': {
				background: '#d9d9d9',
				border: '1px solid #d9d9d9',
			},
		},
	}
})(Button)

export const SecondaryBtn = withStyles(() => {
	return {
		root: {
			color: 'rgba(0, 0, 0, 0.87)',
			fontSize: 13,
			lineHeight: '16px',
			textAlign: 'center',
			fontWeight: 'normal',
			fontStyle: 'normal',
			textTransform: 'inherit',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			boxShadow: 'none',
			border: '1px solid #E0E0E0',
			borderRadius: 4,
			padding: '0 4px ',
			backgroundColor: '#fff',
			height: '32px',
			minWidth: '100px',
			'&:hover': {
				border: '1px solid #3F4F5E',
				backgroundColor: '1px solid rgba(0, 0, 0, 0.03)',
			},
			'&:active': {
				backgroundColor: 'rgba(27, 170, 240, 0.1)',
				border: '1px solid #1baaf0',
				color: '#1baaf0',
			},
		},
		label: {
			display: 'flex',
			alignItems: 'center',
			height: '100%',
		},
	}
})(Button)
export const ExtraButtonBtn = withStyles(() => {
	return {
		root: {
			color: '#02405E',
			fontSize: 13,
			lineHeight: '16px',
			textAlign: 'center',
			fontWeight: 'normal',
			fontStyle: 'normal',
			textTransform: 'inherit',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			boxShadow: 'none',
			borderRadius: 4,
			padding: '0 4px ',
			backgroundColor: '#E0E0E0',
			height: '32px',
			minWidth: '100px',
			'&:hover': {
				backgroundColor: '#E0E0E0',
			},
		},
	}
})(Button)
